import { render, staticRenderFns } from "./CensoBase.vue?vue&type=template&id=636e4dae&scoped=true"
import script from "./CensoBase.vue?vue&type=script&lang=js"
export * from "./CensoBase.vue?vue&type=script&lang=js"
import style0 from "./CensoBase.vue?vue&type=style&index=0&id=636e4dae&prod&lang=scss&scoped=true"
import style1 from "./CensoBase.vue?vue&type=style&index=1&id=636e4dae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636e4dae",
  null
  
)

export default component.exports